/* src/app/modules/employees/booking-bulk-sync-dialog.component.css */
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.dlg-hdr__close {
  color: #6b7280;
}
.dlg-body {
  padding: 24px 24px 8px !important;
  max-height: 60vh;
  overflow-y: auto;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.dlg-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  gap: 6px;
}
.bbs-loading {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}
.bbs-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: #fff8e1;
  border-left: 3px solid #e3fd64;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;
}
.bbs-info mat-icon {
  color: #e3fd64;
  flex-shrink: 0;
  margin-top: 1px;
}
.bbs-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: .8px;
  margin: 16px 0 10px;
}
.bbs-loc-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}
.bbs-loc-row:last-child {
  border-bottom: none;
}
.bbs-role-field {
  flex: 1;
  max-width: 160px;
}
.bbs-empty {
  color: #999;
  font-size: 14px;
  padding: 12px 0;
}
/*# sourceMappingURL=booking-bulk-sync-dialog.component.css.map */
